import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';

import styles from './styles.module.css';

@autobind
export default class ExpandableListItem extends Component {
    static propTypes = {
        label: PropTypes.object,
        expanded: PropTypes.bool,
    };

    state = {
        version: undefined,
        expanded: Boolean(this.props.expanded),
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ expanded: nextProps.expanded });
    }

    handleClick(event) {
        this.setState((state) => ({ expanded: !state.expanded }));
        if (this.props.onClick) return this.props.onClick();
    }

    render() {
        const { expanded } = this.state;
        const { id, children } = this.props;

        return (
            <div key={id} onClick={this.handleClick} className={styles.item}>
                <div className={styles.content}>
                    <div className={styles.persistent}>
                        {this.props.label}
                        <i className='material-icons'>{expanded ? 'expand_less' : 'expand_more'}</i>
                    </div>
                    {expanded && <div className={styles.children}>{children}</div>}
                </div>
            </div>
        );
    }
}
